
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppTemplateVariableMapDialog extends Serenity.EntityDialog<WhatsAppTemplateVariableMapRow, any> {
        protected getFormKey() { return WhatsAppTemplateVariableMapForm.formKey; }
        protected getIdProperty() { return WhatsAppTemplateVariableMapRow.idProperty; }
        protected getLocalTextPrefix() { return WhatsAppTemplateVariableMapRow.localTextPrefix; }
        protected getService() { return WhatsAppTemplateVariableMapService.baseUrl; }
        protected getDeletePermission() { return WhatsAppTemplateVariableMapRow.deletePermission; }
        protected getInsertPermission() { return WhatsAppTemplateVariableMapRow.insertPermission; }
        protected getUpdatePermission() { return WhatsAppTemplateVariableMapRow.updatePermission; }

        protected form = new WhatsAppTemplateVariableMapForm(this.idPrefix);

    }
}